import axios from "axios";
import config from "../config/vars";

let axiosInstance;

export const init = () => {
  axiosInstance = axios.create({
    baseUrl: config.baseUrl
  });
};

export const getAxios = () => {
  if (!axiosInstance) {
    init();
  }
  return axiosInstance;
};

export const setHeader = (header, value) => {
  const instance = getAxios();
  if (value) {
    instance.defaults.headers.common[header] = value;
  } else {
    delete instance.defaults.headers.common[header];
  }
};

export const getCancelator = () => {
  const { CancelToken } = axios;
  return CancelToken.source();
};

export default {
  init,
  getAxios,
  setHeader,
  getCancelator
};
